import { RegisterModule } from '@/typings/common'
import {
  Roadmap as Data,
  RoadmapCollection as Collection,
} from '@/typings/api/Roadmap'
import { RoadmapsApi as Api } from '@/api/resources'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import { RoadmapsAdapter as Adapter } from './RoadmapsAdapter'
import { MODULE_NAME } from '../utils'


const useOptions = () => ({
  adapter: new Adapter(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as roadmapsStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
